import MuiButton from '@material-ui/core/Button';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React from 'react';
import { BLACK_GREY, HIGHLIGHT, TEXT } from '../Colors';
import { BODY } from '../Fonts';
import { Tooltip } from '../Tooltip';

const StyledButton = withStyles({
    root: {
        font: BODY,
        fontWeight: 600,
        borderRadius: '4px',
        color: TEXT,
        textTransform: 'none',
        minHeight: '32px',
        minWidth: '32px',
        padding: '4px 12px',
        '&.MuiButton-contained.Mui-disabled': {
            opacity: 0.5,
            color: TEXT,
            backgroundColor: BLACK_GREY,
        },
        '&.MuiButton-root.Mui-disabled': {
            opacity: 0.5,
            color: TEXT
        }
    },
    contained: {
        backgroundColor: BLACK_GREY,
        "&:hover, &:focus": {
            backgroundColor: HIGHLIGHT
        }
    },
    text: {
        "&:hover, &:focus": {
            color: HIGHLIGHT
        },
        "&:hover": {
            backgroundColor: 'rgba(255, 255, 255, 0.04)'
        }
    }
})(MuiButton);

const useStyles = makeStyles({
    fullWidth: {
        width: '100%',
        minWidth: '0px'
    },
    fullHeight: {
        height: '100%',
        minHeight: '0px'
    },
    hidden: {
        display: 'none',
    },
});

interface ButtonProps {
    type: 'primary' | 'secondary'
    children?: React.ReactNode | React.ReactNode[],
    hidden?: boolean,
    disabled?: boolean,
    autoFocus?: boolean,
    fullWidth?: boolean,
    fullHeight?: boolean,
    href?: string,
    onClick?(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void,
    tooltip?: string,
    tooltipPreferredPlacement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (props.onClick) {
            props.onClick(event);
        }
    }

    const className = `${props.fullWidth ? classes.fullWidth : ''} ${props.fullHeight ? classes.fullHeight : ''} ${props.hidden ? classes.hidden : ''} ${stylingClassName}`;

    if (props.tooltip) {
        return (
            <Tooltip label={props.tooltip} preferredPlacement={props.tooltipPreferredPlacement} hidden={props.hidden}>
                <span>
                    <StyledButton
                        ref={ref}
                        className={className}
                        variant={props.type === "primary" ? "contained" : "text"}
                        disabled={props.disabled}
                        autoFocus={props.autoFocus}
                        onClick={event => onClick(event)}
                        href={props.href}
                    >
                        {props.children}
                    </StyledButton>
                </span>
            </Tooltip>);
    } else {
        return (
            <StyledButton
                ref={ref}
                className={className}
                variant={props.type === "primary" ? "contained" : "text"}
                disabled={props.disabled}
                autoFocus={props.autoFocus}
                onClick={event => onClick(event)}
                href={props.href}
            > 
                {props.children}
            </StyledButton>);
    }
});
